import { Stack } from "@mui/material"

import { useDateParam, useResortParam } from "@/hooks/useSkipassFlow"
import { useBannersQuery, useUserQuery } from "@/queries/hooks"

import MemberBanner from "../MemberBanner"
import PublicBanner from "../PublicBanner"

const BannersList = () => {
  const { resortExternalId } = useResortParam()
  const { startDate } = useDateParam()

  const { data: banners } = useBannersQuery({ resortExternalId, startDate })
  const { data: user, isLoading } = useUserQuery()

  return (
    <Stack direction="column" spacing={0.5}>
      {banners?.map((banner) =>
        banner.isMySkiStarDeal ? (
          <MemberBanner
            key={banner.text}
            text={banner.text}
            isLoggedOut={!user && !isLoading}
          />
        ) : (
          <PublicBanner key={banner.text} text={banner.text} />
        )
      )}
    </Stack>
  )
}

export default BannersList
